import Box from "@mui/material/Box";

import TaskListManager from "./TaskListManager";

/**
 * Standalone screen for the global task catalog (Task List Manager).
 * Fills the available height under the top header so the AG-Grid table can
 * size itself (matches digital_sizer's TaskListsApp height anchoring).
 */
const TaskListManagerScreen = () => (
  <Box
    sx={{
      height: "100%",
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
    }}
  >
    <TaskListManager />
  </Box>
);

export default TaskListManagerScreen;
